export const formatSecondsToMMSS = (seconds: number) => {
  if (seconds === 0) {
    return '00:00'
  }
  const minutes = Math.floor(seconds / 60)
  const secondsLeft = Math.floor(seconds % 60)
  return `${minutes.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`
}
